import { Lock } from '@stratascratch/icons'
import NewBadge from './NewBadge'
import './QuestionTitle.css'

interface QuestionTitleProps {
  title: string
  showLock: boolean
  createdAt?: string | undefined
}

const NEW_QUESTION_THRESHOLD = process.env.NEXT_PUBLIC_NEW_QUESTION_PILLOW

function QuestionTitle({
  title,
  showLock,
  createdAt = undefined,
}: QuestionTitleProps) {
  return (
    <>
      {title}
      {showLock && <Lock className="QuestionTitle__lock-icon" />}
      {NEW_QUESTION_THRESHOLD && <NewBadge date={createdAt} />}
    </>
  )
}

export default QuestionTitle
